import { render, staticRenderFns } from "./profileHeader.vue?vue&type=template&id=0504da4e"
import script from "./profileHeader.vue?vue&type=script&lang=js"
export * from "./profileHeader.vue?vue&type=script&lang=js"
import style0 from "./profileHeader.vue?vue&type=style&index=0&id=0504da4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports